import styled from 'styled-components'

export const IconWrapper = styled.div`
  position: absolute;
  right: 8px;
  display: flex;
`
